import { createRgAPI, asJsonRequest } from '~/api/core/rgRequest';
import { ContextCard, ContextCardForm } from '~/api/models/leadads/context-card';

const contextCardsAPI = createRgAPI('leadads/context_cards');

const getContextCards = (pageId: string): ResponseWith<{cards: ContextCard[]; default: boolean}> => contextCardsAPI.get({ page_id: pageId });

const postContextCard = (pageId: string, form?: ContextCardForm): ResponseWith<ContextCard> => {
  const body = produceRequestData(form);

  const formExists = !!form;

  return asJsonRequest(contextCardsAPI).post({
    page_id: pageId,
    default: !formExists,
    form: body,
  });
};

/* If formData is not provided, we presume that we are creating a default card since none exist. We then use the linkType to
 * determine what values to fill the card with. If formData is provided, we just return an object with all of the
 * correct values
 */
const produceRequestData = (formData?: ContextCardForm) => {
  if (!formData) {
    return {
      title: 'Sign up to find properties that match your tastes!',
      layout_style: 'LIST_STYLE',
      cover_photo: null,
      status: 'ACTIVE',
      content: [
        'New Property Email Alerts',
        'Price Change Alerts',
        'Detailed Property Information',
        'Save your property searches and favorite properties',
        'Agents to Answer Questions Online',
      ],
    };
  }

  return {
    title: formData.headline,
    layout_style: formData.layout,
    cover_photo: formData.image,
    status: 'ACTIVE',
    content: formData.layout === 'LIST_STYLE' ? formData.list.filter(Boolean) : formData.paragraph,
  };
};

export const createCard = async (pageId: string, formData: ContextCardForm): Promise<ContextCard> => {
  try {
    const { data } = await postContextCard(pageId, formData);

    return data;
  } catch (e) {
    throw new Error(e);
  }
};

export const getCards = async (pageId: string): Promise<ContextCard[]> => {
  try {
    const res = await getContextCards(pageId);

    if (res.data.default) {
      return res.data.cards;
    }

    const { data } = await postContextCard(pageId);

    return [data];
  } catch (e) {
    throw new Error(e);
  }
};
